import React, { useEffect, useState } from 'react';

import { Col, Row, Form, Table } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import './styles.css';

import Menu from '../../components/Menu';

import search from '../../assets/images/search.png';
import ativo from '../../assets/images/ativo.png';
import naoAtivo from '../../assets/images/naoativo.png';
import editar from '../../assets/images/edit.png';
import excluir from '../../assets/images/delete.png';
import api from '../../services/api';
import CustomModal from '../../components/CustomModal';
import { useAlert } from 'react-alert';

const Colaboradores = () => {
  const [customers, setCustomers] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [show, setShow] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [load, setLoad] = useState(false);

  const alert = useAlert();

  const getCustomers = async (search = '') => {
    try {
      const { data: { resources }
      } = await api.get('admin/customer', { params: { search } });
      setCustomers(resources.data);
      console.log(resources.data);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      console.log(error.response);
    }
  }


  useEffect(() => {
    getCustomers();
  }, []);

  const handleStatus = async id => {
    try {
      const { data: { resources }
      } = await api.post(`admin/customer/${id}/status`);
      setCustomers(resources.data);
    } catch (error) {
      console.log(error);
    }
  }
  const handleDelete = async id => {
    setShow(true);
    setIdDelete(id);
  }
  const finishDelete = async () => {
    try {
      const { data: { resources }
      } = await api.delete(`admin/customer/${idDelete}`);
      setCustomers(resources.data);
      alert.show("Dados removidos com sucesso!");
    } catch (error) {
      console.log(error);
    }
    setShow(false);
  }
  const handleSearch = (e) => {
    const value = e.target.value;
    setLoad(true);
    setSearchString(value);
    getCustomers(value);
  }
  const handleShow = () => setShow(false);

  return (
    <div className="container-fluid">
      <CustomModal show={show} handleShow={handleShow} onDelete={finishDelete} />
      <Menu />
      <div className="content">
        <Row>
          <Col sm={12} className="col-title">
            <div className="titlePages">
              <h5>Colaboradores</h5>
              <Link to="/colaboradores/novo">
                <button className="btnYellow">NOVO</button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Form className="formSearch">
              <Form.Group controlId="formBasicEmail">
                <Form.Control type="text" placeholder="Buscar" name="search" value={searchString} onChange={handleSearch} />
                <button><img src={search} alt="Icon" /></button>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm={10}>
            {load &&
              <div className="load-table">
                <div className="loading"></div>
              </div>
            }
            <Table responsive>
              <thead>
                <tr>
                  <th className="tableLeft">Título</th>
                  <th className="tableLeft">Tipo</th>
                  <th className="tableLeft">Plano</th>
                  <th className="tableLeft">Valor</th>
                  <th className="tableLeft">Pagamento</th>
                  <th>Ativo</th>
                  <th>Editar</th>
                  <th>Excluir</th>
                </tr>
              </thead>
              <tbody>
                {customers.map((customer, key) => (
                  <tr key={key}>
                    <td className="tableLeft">{customer.name}</td>
                    <td className="tableLeft">{customer.original_role}</td>
                    <td className={`tableLeft ${customer.price === 0 ? 'tableDisabled' : ''}`}>{customer.original_signature}</td>
                    <td className={`tableLeft ${customer.price === 0 ? 'tableDisabled' : ''}`}>{customer.formated_price}</td>
                    <td className={`tableLeft ${customer.price === 0 ? 'tableDisabled' : ''}`}>
                      {customer.price === 0 && `N/A`}
                      {customer.price > 0 && customer.formated_payment_method}
                      {customer?.subscriptions?.status !== 'paid' && customer.payment_method === 'credit_card' &&
                        <>
                          <br /><span className="pendingStatus">pendente</span>
                        </>
                      }
                    </td>
                    <td><img className="imgActive" src={customer.status === 1 ? ativo : naoAtivo} alt="Icon" onClick={() => handleStatus(customer.id)} />{customer.status === 1 ? 'Sim' : 'Não'}</td>
                    <td>
                      <Link to={`/colaboradores/edit/${customer.id}`}>
                        <img className="imgEdit" src={editar} alt="Icon" />
                      </Link>
                    </td>
                    <td><img className="imgDelete" src={excluir} alt="Icon" onClick={() => handleDelete(customer.id)} /></td>
                  </tr>

                ))}

              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Colaboradores;